"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ImageContainer", {
  enumerable: true,
  get: function get() {
    return _textAndImage.ImageContainer;
  }
});
Object.defineProperty(exports, "TextContainer", {
  enumerable: true,
  get: function get() {
    return _textAndImage.TextContainer;
  }
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _image = _interopRequireDefault(require("../contentful-views/image"));

var _Typography = require("../typography/Typography");

var _textAndImage = require("./text-and-image.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TextAndImage = function TextAndImage(_ref) {
  var variant = _ref.variant,
      image = _ref.image,
      title = _ref.title,
      bodyContent = _ref.bodyContent,
      backgroundImage = _ref.backgroundImage,
      backgroundColor = _ref.backgroundColor,
      button = _ref.button,
      showQuote = _ref.showQuote,
      minHeightMobile = _ref.minHeightMobile,
      minHeightDesktop = _ref.minHeightDesktop,
      delegated = _objectWithoutProperties(_ref, ["variant", "image", "title", "bodyContent", "backgroundImage", "backgroundColor", "button", "showQuote", "minHeightMobile", "minHeightDesktop"]);

  var renderTitle = title ? /*#__PURE__*/_react["default"].createElement(_Typography.Heading, {
    as: "h2"
  }, title) : null;
  var renderBodyContent = bodyContent ? /*#__PURE__*/_react["default"].createElement(_textAndImage.BodyContentMarkdown, {
    source: bodyContent
  }) : null;
  var renderImage = image && _typeof(image) === 'object' ? /*#__PURE__*/_react["default"].createElement(_textAndImage.ImageContainer, {
    variant: variant
  }, /*#__PURE__*/_react["default"].createElement(_image["default"], {
    media: image,
    height: 400,
    quality: 70,
    lazy: true,
    imageProps: {
      draggable: 'false'
    }
  })) : null; // We want to provide the complimentary color for our backgroundColor.

  var quoteColor = showQuote && backgroundColor && backgroundColor.split('.').length === 2 ? "".concat(backgroundColor.split('.')[0], ".lightest") : 'magic.lightest';
  return /*#__PURE__*/_react["default"].createElement(_textAndImage.Wrapper, delegated, renderImage, /*#__PURE__*/_react["default"].createElement(_textAndImage.TextContainer, {
    side: variant,
    backgroundImage: backgroundImage,
    backgroundColor: backgroundColor,
    backgroundImagePosition: "alignLeft",
    minHeightMobile: minHeightMobile,
    minHeightDesktop: minHeightDesktop,
    showOverlay: false
  }, showQuote ? /*#__PURE__*/_react["default"].createElement(_textAndImage.FloatQuote, {
    color: quoteColor
  }, "\u201C") : null, /*#__PURE__*/_react["default"].createElement(_textAndImage.Background, {
    backgroundImage: backgroundImage
  }), /*#__PURE__*/_react["default"].createElement(_textAndImage.TextContentWrapper, {
    variant: variant
  }, renderTitle, renderBodyContent, button)));
};

TextAndImage.propTypes = {
  variant: _propTypes["default"].oneOf(['left-image', 'right-image']),
  image: _propTypes["default"].object.isRequired,
  title: _propTypes["default"].string,
  bodyContent: _propTypes["default"].string,
  backgroundImage: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string,
  button: _propTypes["default"].shape({}),
  minHeightDesktop: _propTypes["default"].string,
  minHeightMobile: _propTypes["default"].string,
  showQuote: _propTypes["default"].bool
};
TextAndImage.defaultProps = {
  variant: 'right-image',
  imageUrl: null,
  title: null,
  bodyContent: null,
  backgroundImage: null,
  backgroundColor: null,
  button: null,
  minHeightMobile: '250px',
  minHeightDesktop: '400px',
  showQuote: false,
  quoteColor: 'magic.lightest'
};
var _default = TextAndImage;
exports["default"] = _default;